import { Routes } from '@angular/router';

export const registrationLetterRoutes: Routes = [
  {
    path: 'registration-letters',
    loadComponent: () =>
      import('./list-registration-letters/list-registration-letters').then((c) => c.ListRegistrationLetters),
  },
];
